import { PEER } from '../../constants'

/**
 * Event wrapper for `icegatheringstatechange` event.
 * Reference: developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/onicegatheringstatechange
 * @method onicegatheringstatechange
 * @param  {Function} listener The listener function for the event.
 * @return {Boolean}  Whether the assignment succeeded or not.
 */
export default function onicegatheringstatechange (listener) {
  const { nativePeer, iceTimer, log } = this

  /**
   * Intercept the PeerConnection onicegatheringstatechange event.
   * Time how long ICE collection takes and handles scenarios when it takes
   *    too long.
   */
  nativePeer.onicegatheringstatechange = event => {
    const gatheringState = event.target.iceGatheringState
    log.debug(`Peer iceGatheringState changed to ${gatheringState}.`)

    if (gatheringState === PEER.ICE_GATHERING_STATE.GATHERING) {
      iceTimer.start()
      // TODO: Handle "ICE collection taking too long" scenario.
    } else if (gatheringState === PEER.ICE_GATHERING_STATE.COMPLETE) {
      log.debug(`Peer took ${iceTimer.timeFromStart()}ms to collect ICE candidates.`)
      iceTimer.stop()
    }
    // Bubble the event up.
    listener(event)
  }

  return true
}
